import React, { useRef, useState, useContext, useEffect } from 'react';
import { IonModal, IonSlides, IonSlide, IonItem, IonInput, IonButton, IonHeader, IonGrid, IonRow, IonCol, IonLabel, IonContent, IonFooter, IonTitle, IonButtons, IonToolbar, } from '@ionic/react';


import '../../css/layout.css';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';
import {RegisterIndividualModal} from './Register_Individual_Modal';
import { MerchantLoginCredentials } from './LoginCredentials_merchant';

export function Application_SubmissionModal(props) {

    let authClient_context = useContext(Auth_MerchantID_context);

    let [baseURL, setBaseURL ] = useState(window.location.origin+"/");
    const [acctID, setAcctID ] = useState(authClient_context.acctID);
    const [schema, setSchemaName] = useState(authClient_context.schema);
    let [authenticated, setIsAuthenticated] = useState(authClient_context.authenticated);
    let [sessionID, setSessionID ] = useState(authClient_context.sessionID);

    let [applicantCountryRegion, setApplicantCountryRegion] = useState('');
    let [applicantCountry, setApplicantCountry] = useState('');
    let [disableSubmitApplicationButton, setDisableSubmitApplicaitonButton] = useState(false);
    const [companyAcctID, setCompanyAcctID ] = useState(props.data.companyAcctID);

    let [registerModal_individial, setRegisterModal_individual] = useState(false);
    let [saveEvent, setSaveEvent] = useState([]);
    
        let [merchantLoginModal, setMerchantLoginModal] = useState(false);
    
    let [username, setUsername] = useState('');
    let [password, setPassword] = useState('');


    let [currentFirstName, setCurrentFirstName] = useState('');
    let [currentLastName, setCurrentLastName] = useState('');
    let [currentUsername, setCurrentUsername] = useState('');
    let [currentPassword, setCurrentPassword] = useState('');
    let [currentPhoneNumber, setCurrentPhoneNumber] = useState('');
    let [currentEmail, setCurrentEmail] = useState('');
    let [currentAddressNumber, setCurrentAddressNumber] = useState('');
    let [currentStreetName, setCurrentStreetName] = useState('');
    let [currentCity, setCurrentCity] = useState('');
    let [currentCityDistrict, setCurrentCityDistrict] = useState('');
    let [currentCountryRegion, setCurrentCountryRegion] = useState('');
    let [currentCountry, setCurrentCountry] = useState('');
    let [currentDigitalAddress, setCurrentDigitalAddress] = useState('');
    let [currentEmployeeAttachement, setCurrentEmployeeAttachement] = useState('');
    let [selectedFile, setSelectedFile] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");

    let [companyRole, setCompanyRole] = useState(null);
    let [hireDate, setHireDate] = useState(null);
    let [hourlyPay, setHourlyPay] = useState(null);
    let [jobFunction, setJobFunction] = useState(null);

    let enterFirstNameRef = useRef(null);
    let enterMiddleNameRef = useRef(null);
    let enterLastNameRef = useRef(null);
    let enterMobileNumberRef = useRef(null);
    let enterEmailRef = useRef(null);

    let applicantAddressNumberRef = useRef('');
    let applicantStreetNameRef = useRef('');
    let applicantCityRef = useRef('');
    let applicantCityDistrictRef = useRef('');
    let applicantCountryRegionRef = useRef('');
    let applicantCountryRef = useRef('');
    let applicantDigitalAddressIDRef = useRef('');
    let applicantTextRef = useRef('');

    function getApplicantInfo()
    {
                const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                //Tracker: "74503_requisitions_overview",
                Tracker: "uu_get_applicant_info",
                user: acctID,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'userAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            //alert(res);

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                    setCompanyRole(cols[1]);
                    setCurrentFirstName(cols[2]);
                    setCurrentLastName(cols[3]);
                    setCurrentUsername(cols[4]);
                    setCurrentPassword(cols[5]);
                    setHireDate(cols[6]);
                    setHourlyPay(cols[7]);
                    setJobFunction(cols[8]);
                    setCurrentPhoneNumber(cols[9]);
                    setCurrentEmail(cols[10]);
                    setCurrentAddressNumber(cols[11]);
                    setCurrentStreetName(cols[12]);
                    setCurrentCity(cols[13]);
                    setCurrentCityDistrict(cols[14]);
                    setCurrentCountryRegion(cols[15]);
                    setCurrentCountry(cols[16]);
                    setCurrentDigitalAddress(cols[17]);
                    setCurrentEmployeeAttachement(cols[18]);

                    setCurrentEmployeeAttachementHandler(cols[18]);
            } 
        })
    }

    function submitApplication(saveEvent, event1, accountID)
    {
        setDisableSubmitApplicaitonButton(true);

        let formData = new FormData();
        formData.append('Tracker', '74503_submitApplication_public');
        formData.append('user', accountID);
        formData.append('merchantSchema', schema);
        formData.append('xJobRequisitionID', props.data.requisitionID);
        formData.append('xJobRequisitionName', props.data.requisitionName);
        formData.append('xApplicantFirstName', currentFirstName.replace(/\s+/g, ''));
        //formData.append('xApplicantMiddleName', currentLastName.replace(/\s+/g, ''));
        formData.append('xApplicantLastName', currentLastName.replace(/\s+/g, ''));
        formData.append('xApplicantMobileNumber', currentPhoneNumber.replace(/\s+/g, ''));
        formData.append('xApplicantEmail', currentEmail.replace(/\s+/g, ''));
        formData.append('xApplicantAddressNumber', currentAddressNumber.replace(/\s+/g, ''));
        formData.append('xApplicantStreetName', currentStreetName.replace(/\s+/g, ''));
        formData.append('xApplicantCity', currentCity.replace(/\s+/g, ''));
        formData.append('xApplicantCityDistrict', currentCityDistrict.replace(/\s+/g, ''));
        formData.append('xApplicantCountryRegion', applicantCountryRegion);
        formData.append('xApplicantCountry', applicantCountry);
        formData.append('xApplicantDigitalAddressID', currentDigitalAddress);
        formData.append('xResume', selectedFile);
        formData.append('xApplicationText', applicantTextRef.current.value)
        formData.append('xCompanyID_public', props.data.companyAcctID)

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            //credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }

        let newBaseURL = 'https://ghanaverified.com';
        if(baseURL == 'https://bluefinhoteltest.com/' || baseURL == 'https://bluefinhoteltest.com/overviewTab')
        {
            newBaseURL = 'https://ghanaverifiedtest.com'
        }

        fetch(baseURL+'ghanaverified/', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            //props.closeModal(false);
            window.location.href = '/jobs';

        })
        .catch(error => {
            console.error(error);
        })
    }

    function setCurrentEmployeeAttachementHandler(event) {  

        fetch(baseURL+event)
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let initialFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setSelectedFile(initialFile);
        })
    }

    function handleFileChange(event) {


        const file = event.target.files ? event.target.files[0] : null;
        setSelectedFile(file);
        //setFileName(file ? file.name : '');
    }

    function handleSubmitApplication()
    {
        setDisableSubmitApplicaitonButton(true);

        if(acctID == null)
        {
            //authMerchant_objects.changeAccountID('register_request');
            //setSaveEvent(event);
            setRegisterModal_individual(true);
        }
        if(acctID != null)
        {
            submitApplication(null, null, acctID);
        }
    }

    function handleCloseModal_merchantLogin(event)
    {

        if(event[0] == 'REGISRATION_LOGIN_COMPLETED')
        {
            setIsAuthenticated(event[1]);
            setAcctID(event[2]);
            submitApplication(null, event[1], event[2]);
        }
        else
        {
            alert('LOGIN FAILED, PLEASE TRY AGAIN.');
            //merchantLoginModal(false);
        }
        
    }

    function handleCloseModal(event)
    {

        setUsername(event[0]);
        setPassword(event[1]);
        setRegisterModal_individual(false);
        setMerchantLoginModal(true);
    }

    function closeModalHandler() {

        props.closeModal(false);
    }

    useEffect(() => {

        if(acctID != null)
        {
            getApplicantInfo();
        }

    }, [])


    return (
        <React.Fragment>
        {props.openModal == true ?
        (
            <IonModal isOpen={ props.openModal }>
            <IonHeader >
                    <IonToolbar>
                    <IonTitle>{"REQ ID: "+props.data.requisitionID+" - "+props.data.requisitionName}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton fill="outline" color="success" onClick={closeModalHandler}>Close</IonButton>
                    </IonButtons>
                    </IonToolbar>
            </IonHeader> 
            <IonContent className='appContent'>  
                    <IonGrid >
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>First Name: </IonLabel>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput className='professional-input' type='text' value={currentFirstName} placeholder='Enter First Name' autocomplete='off' onIonChange={(e) => setCurrentFirstName(e.target.value)} required></IonInput>
                            </IonCol>
                        </IonRow>
                        {/*<IonRow>
                            <IonCol size='6'>
                                <IonLabel>Middle Name: </IonLabel>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput placeholder='Enter Middle Name' ref={enterMiddleNameRef }></IonInput>
                                <IonInput className='professional-input' type='text' value={currentFirstName} placeholder='Enter First Name' autocomplete='off' onIonChange={(e) => setCurrentFirstName(e.target.value)} required></IonInput>
                            </IonCol>
                        </IonRow>*/}
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>Last Name: </IonLabel>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput className='professional-input' type='text' value={currentLastName} placeholder='Enter Last Name' autocomplete='off' onIonChange={(e) => setCurrentLastName(e.target.value)} required></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>Mobile Number: </IonLabel>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput className='professional-input' type='text' value={currentPhoneNumber} placeholder='Enter PhoneNumber' autocomplete='off' onIonChange={(e) => setCurrentPhoneNumber(e.target.value)} required></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>Email: </IonLabel>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput className='professional-input' type='text' value={currentEmail} placeholder='Enter Email' autocomplete='off' onIonChange={(e) => setCurrentEmail(e.target.value)} required></IonInput>
                            </IonCol>
                        </IonRow>
                        {/*<IonRow>
                            <IonCol size='6'>
                                <IonLabel>Address Number: </IonLabel>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput className='professional-input' type='text' value={currentAddressNumber} placeholder='Enter Address #' autocomplete='off' onIonChange={(e) => setCurrentAddressNumber(e.target.value)} required></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>Street Name: </IonLabel>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput className='professional-input' type='text' value={currentStreetName} placeholder='Enter Street' autocomplete='off' onIonChange={(e) => setCurrentStreetName(e.target.value)} required></IonInput>
                            </IonCol>
                        </IonRow>*/}
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>City: </IonLabel>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput className='professional-input' type='text' value={currentCity} placeholder='Enter City' autocomplete='off' onIonChange={(e) => setCurrentCity(e.target.value)} required></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>City District: </IonLabel>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput className='professional-input' type='text' value={currentCityDistrict} placeholder='Enter City District' autocomplete='off' onIonChange={(e) => setCurrentCityDistrict(e.target.value)} required></IonInput>
                            </IonCol>
                        </IonRow>
                        {/*<IonRow>
                            <IonCol size='6'>
                                <IonLabel>Digital Address: </IonLabel>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput className='professional-input' type='text' value={currentDigitalAddress} placeholder='Enter Digital Address' autocomplete='off' onIonChange={(e) => setCurrentDigitalAddress(e.target.value)} required></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel htmlFor="country">Country</IonLabel>                                    
                            </IonCol>
                            <IonCol size='6'>
                                <select name="country" id='country' onChange={(e) => setApplicantCountry(e.target.value) }>
                                    <option value='Ghana' selected='selected'>Ghanian</option>
                                    <option value='Non-Ghanian'>Non-Ghanian</option>
                                </select>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel htmlFor="paymenttype">Region</IonLabel>                                    
                            </IonCol>
                            <IonCol size='6'>
                                <select name="countryRegion" id='countryRegion' onChange={(e) => setApplicantCountryRegion(e.target.value) }>
                                    <option value='Eastern' selected='selected'>Eastern</option>
                                    <option value='Western'>Western</option>
                                    <option value='Central'>Central</option>
                                    <option value='Northern'>Northern</option>
                                </select>
                            </IonCol>
                        </IonRow>*/}
                        <IonRow>
                            <IonCol size='4'>Resume</IonCol>
                            <IonCol size='8'>
                                <form id='fileUpload' encType='multipart/form-data'>
                                        <input id='application_resume' type='file' name='xResume' accept=".doc,.docx,.pdf,.jpeg,.jpg,.png,.odt" onChange={(event) => handleFileChange(event)} required></input>
                                </form>                                        
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                TELL US ABOUT YOURSELF
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <textarea cols="50" rows="10" placeholder='Enter Position Qualifications (3000 characters max)' ref={ applicantTextRef }></textarea>
                            </IonCol>
                        </IonRow>

                    </IonGrid>
            </IonContent>
            <IonFooter className='grid_footer'>
                <IonGrid>
                    <IonRow>
                        <IonCol>
                                <IonButton disabled={disableSubmitApplicationButton} onClick={() => handleSubmitApplication()}> Submit Application </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonFooter>

            {registerModal_individial == true && <RegisterIndividualModal  openModal={registerModal_individial} closeModal={(event) => handleCloseModal(event)} payCloseModal={(event) => setRegisterModal_individual(event)} data={{
                                                    source: 'online_application_submission', 
                                                    register_firstName: currentFirstName,
                                                    register_lastName: currentLastName,
                                                    register_phoneNumber: currentPhoneNumber,
                                                    }}></RegisterIndividualModal>}
            {merchantLoginModal == true && <MerchantLoginCredentials openModal={ merchantLoginModal } closeModal={(event) => handleCloseModal_merchantLogin(event)} payCloseModal={(event) => setMerchantLoginModal(event)} data={{
                                                    source: 'online_application_register_completed',
                                                    username: username, 
                                                    password: password,
                                                    }}></MerchantLoginCredentials>}
                                                    
            </IonModal>
            ) : null}
    </React.Fragment>
    )
}
